export default "__VITE_ASSET__ja2ES54K__"